import Layout from '../components/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Receipt, BarChart3, Users, TrendingUp, Wallet, Target } from 'lucide-react';
import { ExpenseReport, ProfitReport, EmployeeSalaryReport, SilicaUsageDashboard, AccountBalanceReport, MonthlyTargetReport } from '../components/reports';

export default function Reports() {
  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <p className="text-amber-600 text-sm font-bold tracking-[0.15em] uppercase mb-1">Analytics</p>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "'Manrope', sans-serif" }}>Reports</h1>
          <p className="text-slate-500 mt-1">Financial and operational reports</p>
        </div>
        
        <Tabs defaultValue="profit" className="w-full">
          <TabsList className="grid w-full grid-cols-3 sm:grid-cols-6 h-auto gap-2 bg-transparent p-0">
            <TabsTrigger value="profit" className="data-[state=active]:bg-slate-900 data-[state=active]:text-white rounded-xl py-3 flex items-center gap-2">
              <BarChart3 className="w-4 h-4" />
              <span className="hidden sm:inline">Profit Report</span>
              <span className="sm:hidden">Profit</span>
            </TabsTrigger>
            <TabsTrigger value="expense" className="data-[state=active]:bg-slate-900 data-[state=active]:text-white rounded-xl py-3 flex items-center gap-2">
              <Receipt className="w-4 h-4" />
              <span className="hidden sm:inline">Expense Report</span>
              <span className="sm:hidden">Expenses</span>
            </TabsTrigger>
            <TabsTrigger value="silica" className="data-[state=active]:bg-slate-900 data-[state=active]:text-white rounded-xl py-3 flex items-center gap-2">
              <TrendingUp className="w-4 h-4" />
              <span className="hidden sm:inline">Silica Usage</span>
              <span className="sm:hidden">Silica</span>
            </TabsTrigger>
            <TabsTrigger value="salary" className="data-[state=active]:bg-slate-900 data-[state=active]:text-white rounded-xl py-3 flex items-center gap-2">
              <Users className="w-4 h-4" />
              <span className="hidden sm:inline">Employee Salary</span>
              <span className="sm:hidden">Salary</span>
            </TabsTrigger>
            <TabsTrigger value="balance" className="data-[state=active]:bg-slate-900 data-[state=active]:text-white rounded-xl py-3 flex items-center gap-2">
              <Wallet className="w-4 h-4" />
              <span className="hidden sm:inline">Balances</span>
              <span className="sm:hidden">Balances</span>
            </TabsTrigger>
            <TabsTrigger value="targets" className="data-[state=active]:bg-slate-900 data-[state=active]:text-white rounded-xl py-3 flex items-center gap-2" data-testid="tab-targets">
              <Target className="w-4 h-4" />
              <span className="hidden sm:inline">Monthly Targets</span>
              <span className="sm:hidden">Targets</span>
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="profit" className="mt-6">
            <ProfitReport />
          </TabsContent>
          
          <TabsContent value="expense" className="mt-6">
            <ExpenseReport />
          </TabsContent>
          
          <TabsContent value="silica" className="mt-6">
            <SilicaUsageDashboard />
          </TabsContent>
          
          <TabsContent value="salary" className="mt-6">
            <EmployeeSalaryReport />
          </TabsContent>
          
          <TabsContent value="balance" className="mt-6">
            <AccountBalanceReport />
          </TabsContent>

          <TabsContent value="targets" className="mt-6">
            <MonthlyTargetReport />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
